import axios from '@/plugins/http/axios.js';
import config from "@/views/novelties/config/novelties_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
    getListNovelties : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/newsUpdates/list/`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
    
    postCreateNovelty: (idGroup, idEmpresa, idUsuario, formdata) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/newsUpdates/create/`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            },
            data: formdata,
            redirect: 'follow'
        })
    },

    postUpdateNovelty: (idGroup, idEmpresa, idUsuario, data, newsUpdateId) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/newsUpdates/update/${newsUpdateId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            },
            data: data,
            redirect: 'follow'
        })
    },

    getDeleteNovelty: (idGroup, idEmpresa, idUsuario, newsUpdateId) => {
        return axios({
            method: 'delete',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/newsUpdates/delete/${newsUpdateId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
}
